import { configureStore } from "@reduxjs/toolkit";

import { storeKeyName } from "../common/AppConstant";

import { slice as authSlice } from "./AuthStore";
import { slice as dataGraphSlice } from "./DataGraphStore";
import { slice as fileSlice } from "./FileStore";
import { slice as officeSlice } from "./OfficeStore";
import { slice as referenceLineSlice } from "./ReferenceLineStore";
import { slice as registerSlice } from "./RegisterStore";
import { slice as remoteMaintenanceSlice } from "./RemoteMaintenanceStore";
import { slice as reportSlice } from "./ReportStore";

/**
 * Storeの設定.
 *
 * @type {object}
 */
const store = configureStore({
  reducer: {
    [storeKeyName.auth]: authSlice.reducer,
    [storeKeyName.file]: fileSlice.reducer,
    [storeKeyName.register]: registerSlice.reducer,
    [storeKeyName.office]: officeSlice.reducer,
    [storeKeyName.dataGraph]: dataGraphSlice.reducer,
    [storeKeyName.report]: reportSlice.reducer,
    [storeKeyName.remoteMaintenance]: remoteMaintenanceSlice.reducer,
    [storeKeyName.referenceLine]: referenceLineSlice.reducer,
  },
});

export default store;
